import { LibraryListItem } from '@/shared/helpers/api';

export type CreatePackageParameters = {
    packageType: string;
    description: string;
    options: object;
};

export type WizardType = 'LibraryDefinitions' | 'LibraryContent';

export interface ShippingWizard<T> {
    type: WizardType;
    addLibrary(library: LibraryListItem): Promise<void>;
    removeLibrary(name: string): void;
    // Moves a library up (negative offset) or down (positive offset) in the setup
    moveLibrary(name: string, offset: number): void;
    // Populates the wizard from a saved package setup. Returns descriptions of anything that could not be restored.
    loadSaved(options: object, availableLibraries: LibraryListItem[]): Promise<string[]>;
    finish(): CreatePackageParameters;
    elements: T[];
};

export type LibraryItemFilter = (library: LibraryListItem) => boolean;

export function moveLibraryElement<T extends { libraryName: string }>(elements: T[], name: string, offset: number): void {
    const from = elements.findIndex(x => x.libraryName === name);
    const to = from + offset;
    if (from < 0 || to < 0 || to >= elements.length)
        return;

    const [moved] = elements.splice(from, 1);
    elements.splice(to, 0, moved);
}
